module.exports = __webpack_public_path__ + "static/media/doggo.a3afcd27.png";